import Login from './container'

export default Login

// Moved reducer to static/sync reducer as actions may be fired
// when login reducer was not attached yet.

// import withReducer from 'store/withReducer'
// import reducer from './module'
// export default withReducer('Login', reducer)(Login)



// WEBPACK FOOTER //
// ./src/legacy/pages/Login/index.js